import { colorsPalettes } from "@similarweb/styles";
import { ProgressBar } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { ICategoryComparison } from "app/pages/industry-analysis/categories-context";
import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context";

import type { IGenderChartDistributionData } from "../../types";

import { GenderDistributionComparisonLegendBulletItems } from "./GenderDistributionComparisonLegendBulletItems";

const PRIMARY_COLOR_SET = [colorsPalettes.midnight["300"], colorsPalettes.midnight["100"]];
const COMPARED_COLOR_SET = [colorsPalettes.orange["400"], colorsPalettes.orange["200"]];

const labelRenderer = (value: number) => {
    return (
        <Flex
            margin="0 0 0 2px"
            data-automation="gender-distribution-label"
        >
            {(value * 100).toFixed(1)}%
        </Flex>
    );
};

type GenderDistributionComparisonShareBarProps = {
    category: ICategoryComparison;
    data: IGenderChartDistributionData;
};

export const GenderDistributionComparisonShareBar = ({ category, data }: GenderDistributionComparisonShareBarProps) => {
    const { primaryCategory } = useCategoriesComparison();

    const isPrimary = category.category.id === primaryCategory.id;
    const colorSet = isPrimary ? PRIMARY_COLOR_SET : COMPARED_COLOR_SET;
    const values = [data.malePercent / 100, data.femalePercent / 100];

    return (
        <Flex
            gap="8px"
            flexDirection="column"
        >
            <Flex
                justifyContent="space-between"
                alignItems="center"
            >
                <Text fontVariant="body2">{category.category.text}</Text>
                <GenderDistributionComparisonLegendBulletItems
                    values={values}
                    colorSet={colorSet}
                />
            </Flex>
            <ProgressBar
                showLabels
                height="16px"
                values={values}
                colorSet={colorSet}
                labelRenderer={labelRenderer}
            />
        </Flex>
    );
};
